import { TimelineLayoutMode } from '../trace/timeline/TimelineTraceDataTransformer'

export class TidewaysStorage {
    private static TimelineLayoutModeKey = 'timeline:layout-mode'

    private static getLocalStorage(): Storage | null {
        if (typeof window === 'undefined' || typeof window.localStorage === 'undefined') {
            return null
        }

        try {
            return window.localStorage
        } catch (_error) {
            return null
        }
    }

    public static getTimelineLayoutMode(): TimelineLayoutMode {
        const storage = this.getLocalStorage()
        const initialValue: TimelineLayoutMode = 'condensed'

        if (!storage) {
            return initialValue
        }

        const value = storage.getItem(this.TimelineLayoutModeKey)

        if (value === 'classic' || value === 'condensed' || value === 'waterfall') {
            return value
        }

        return initialValue
    }

    public static setTimelineLayoutMode(layoutMode: TimelineLayoutMode): void {
        const storage = this.getLocalStorage()

        if (!storage) {
            return
        }

        storage.setItem(this.TimelineLayoutModeKey, layoutMode)
    }
}
